import {
  Place,
  USStateFullNames,
  USStates,
  usStateAbbreviationToName,
  usStateNameToAbbreviation,
} from '@trucksmarter/shared';
import { toTitleCase } from '@trucksmarter/shared_frontend';

export function formatCityAndState(city: string | null, state: string | null) {
  return city ? `${toTitleCase(city)}${state ? `, ${state}` : ''}` : state;
}

export function formatLocation({
  type,
  state,
  city,
  street,
  street2,
}: Place): string {
  const stateAbbr = state
    ? usStateNameToAbbreviation[state as USStateFullNames] ?? state
    : '';

  switch (type) {
    case 'address':
      return `${street}, ${
        street2 ? `${street2}, ` : ''
      } ${city}, ${stateAbbr}`;
    case 'city':
      return `${city}, ${stateAbbr}`;
    case 'state':
      return `${stateAbbr} - ${
        state === stateAbbr
          ? usStateAbbreviationToName[stateAbbr as USStates]
          : state
      }`;
    default:
      return '';
  }
}
